import React from "react";
import { useNavigate } from "react-router-dom";

interface PostManagementHeaderProps {
  onNewCategory: () => void;
}

export const PostManagementHeader: React.FC<PostManagementHeaderProps> = ({
  onNewCategory,
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="m-0 text-blue-500 text-2xl font-bold">
        Zarządzanie Postami
      </h1>
      <div className="flex gap-3">
        <button
          onClick={onNewCategory}
          className="px-4 py-2 bg-green-500 text-white border-0 rounded-md cursor-pointer text-sm hover:bg-green-600 transition-colors"
        >
          Nowa Kategoria
        </button>
        <button
          onClick={() => navigate("/post/new")}
          className="px-4 py-2 bg-blue-500 text-white border-0 rounded-md cursor-pointer text-sm hover:bg-blue-600 transition-colors"
        >
          Nowy Post
        </button>
      </div>
    </div>
  );
};
